import 'choerodon-ui/lib/style/index.less';
import 'choerodon-ui/lib/collapse/style';
import 'choerodon-ui/lib/tag/style';
import 'choerodon-ui/lib/popover/style';
import './index.less';
// style dependencies
import '../../form/style';
import '../../button/style';
import '../../radio/style';
import '../../check-box/style';
import '../../text-field/style';
import '../../select/style';
import '../../select-box/style';
import '../../switch/style';
import '../../spin/style';
import '../../modal-container/style';
import '../../tooltip/style';
import '../../menu/style';
import '../../dropdown/style';
import '../../number-field/style';
import '../../date-picker/style';
import '../../table/customization-settings/style';
import '../../table/query-bar/style';
